import type { useCodiea } from "@codiea/tracking/react";

export type PartnerLeadFormId = "distribution" | "reseller_api" | "affiliate";

const FORM_NAMES: Record<PartnerLeadFormId, string> = {
  distribution: "Distribution Partner",
  reseller_api: "Reseller API",
  affiliate: "Affiliate Partner",
};

type CodieaApi = Pick<ReturnType<typeof useCodiea>, "track" | "identify">;

export type PartnerLeadFields = {
  email?: string;
  name?: string;
  phone?: string;
  company?: string;
  message?: string;
  [key: string]: unknown;
};

function getPageContext() {
  if (typeof window === "undefined") {
    return { page_path: undefined, page_url: undefined };
  }
  return {
    page_path: window.location.pathname,
    page_url: window.location.href,
  };
}

export function trackPartnerLead(
  { track, identify }: CodieaApi,
  formId: PartnerLeadFormId,
  fields: PartnerLeadFields,
) {
  const email =
    typeof fields.email === "string" && fields.email.trim()
      ? fields.email.trim()
      : undefined;
  const name =
    typeof fields.name === "string" && fields.name.trim()
      ? fields.name.trim()
      : undefined;

  const { page_path, page_url } = getPageContext();

  void track({
    event: "lead",
    properties: {
      ...fields,
      email,
      name,
      form_id: formId,
      form_name: FORM_NAMES[formId],
      lead_type: formId,
      page_path,
      page_url,
    },
  });

  if (email) {
    void identify({
      traits: {
        email,
        ...(name ? { name } : {}),
      },
    });
  }
}
